<template>
  <div class="login-body">
    <!-- 菜单 -->
    <websiteMenu></websiteMenu>
    <img class="mobeil-title" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-title.png">
    <div class="question-box">
      <img class="mobeil-ip" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-ip.png">
      <img class="mobeil-footer"
        src="https://pdsite.partydaysport.com/official_website/buyTickets/login-mobeil-footer.png">
      <!-- <div class="dialog-back">
        <el-button size="mini" type="primary" @click="goBack">
          <div>返回</div>
          <div>Return</div>
        </el-button>
      </div> -->
      <img class="login-title" src="https://pdsite.partydaysport.com/official_website/buyTickets/login-title.png">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="Phone (電話):" prop="phone">
          <el-input placeholder="Please Enter Phone" v-model="form.phone" class="input-with-select" clearable>
            <el-select v-model="globalCode" slot="prepend" filterable>
              <el-option v-for="(item, index) in globalCodeOptions" :key="index"
                :label="'+' + item.dialCode + ' - ' + item.name" :value="item.dialCode"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="Password (密碼):" prop="pwd">
          <el-input type="password" v-model="form.pwd" placeholder="Please Enter Password" show-password
            clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="submitForm">
          <h1>
            <div class="cn">登入</div>
            <div class="en">Log In</div>
          </h1>
        </el-button>
      </div>
      <!-- 忘記密碼 -->
      <div class="action-button">
        <div class="en-title">I don't have an account yet？</div>
        <div class="cn-title">還沒有帳戶？</div>
        <div class="singel-btn">
          <div class="btn" @click="goRegister">
            <i class="el-icon-circle-plus"></i>
            立即注册
          </div>
          <div class="btn" @click="goForgotPassword">
            <i class="el-icon-question"></i>
            忘記密碼
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { webLogin } from "@/api/index";
import websiteMenu from '@/components/website-menu.vue'
export default {
  components: {
    websiteMenu
  },
  data() {
    return {
      // 表单参数
      form: {},
      globalCode: "",//区号
      // globalCodeOptions: require('country-telephone-data').allCountries,
      globalCodeOptions: [
        {
          dialCode: "86",
          name: "China (中国)"
        },
        {
          dialCode: "852",
          name: "Hong Kong (香港)"
        },
      ],
      // 表单校验
      rules: {
        phone: [{ required: true, message: "Please Enter Phone", trigger: "blur" }],
        pwd: [{ required: true, message: "Please Enter Password", trigger: "blur" }],
      },
      loading: false,
      languageType: null,//语言类型
    };
  },
  mounted() {
    if (localStorage.getItem('satoken')) {
      this.$router.replace('/myTicket')
      return
    }
    this.reset()
  },
  methods: {
    // 表单重置
    reset() {
      this.form = {
        phone: undefined,
        pwd: undefined,
      };
      this.globalCode = "86"
    },
    // 提交表单
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.loading = true
          webLogin({
            ...this.form,
            phone: '+' + this.globalCode + this.form.phone
          })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  message: 'Login succeeded',
                  type: 'success'
                });
                localStorage.setItem('satoken', res.data.data)//存储token
                this.$router.replace('/myTicket')

              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error'
                });

              }
            }).finally(() => {
              this.loading = false
            })
        }
      });
    },
    // 返回
    goBack() {
      // 缓存语言
      var storageLang = localStorage.getItem('language');
      if (storageLang) {
        if (storageLang == 'cn') {
          window.location.href = "/cn/index.html";
        } else if (storageLang == 'en') {
          window.location.href = "/en/index.html";
        } else if (storageLang == 'tc') {
          window.location.href = "/tc/index.html";
        }
        return
      }
      // 浏览器语言
      var lang = navigator.language || navigator.userLanguage;
      if (lang.startsWith("zh")) {
        window.location.href = "/cn/index.html";
      } else {
        window.location.href = "/en/index.html";
      }
    },
    // 注册
    goRegister() {
      this.$router.push('/register')
    },
    // 忘記密碼
    goForgotPassword() {
      this.$router.push('/forgotPassword')
    }
  },
};
</script>
<style lang="less">
.input-with-select .el-select .el-input {
  width: 150px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-form-item__label {
  font-size: 12px;
  line-height: 20px;
}

.el-input__inner,
.el-textarea__inner {
  font-size: 12px;
}

.el-button--primary {
  background-color: #000;
  border-color: #000;
}

.el-button--primary.is-plain {
  background-color: #fff;
  border-color: #000;
  color: #000;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: rgba(0, 0, 0, .8);
  border-color: rgba(0, 0, 0, .8);
}

.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background: #fff;
  border-color: rgba(0, 0, 0, .8);
  color: rgba(0, 0, 0, .5);
}

.dialog-back {
  position: absolute;
  right: 30px;
  top: 20px;
}

.login-title {
  width: 40%;
  height: auto;
  margin-bottom: 10px;
}

.login-body {
  width: 100%;
  height: 100vh;
  background-image: url(https://pdsite.partydaysport.com/official_website/buyTickets/login-bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;


  .mobeil-title,
  .mobeil-footer,
  .mobeil-ip {
    display: none;
  }

  .question-box {
    width: 450px;
    height: 450px;
    position: fixed;
    right: 80px;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 15px;
    padding: 15px 30px 30px;
    background-color: #fff;
    box-sizing: border-box;
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .el-button {
      width: 100%;

      .en,
      .cn {
        font-size: 12px;
      }
    }
  }

  .action-button {
    border-top: 1px solid rgba(0, 0, 0, .2);
    margin-top: 20px;
    padding-top: 10px;
    font-size: 15px;

    .en-title {
      font-weight: bold;
    }

    .singel-btn {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;

      .btn {
        cursor: pointer;
      }
    }
  }
}

/* 响应式设计：在屏幕宽度小于 480px 时调整字体和布局 */
@media (max-width: 780px) {

  .el-select-dropdown__item {
    white-space: normal !important;
    word-break: break-all !important;
  }

  .el-select-dropdown {
    left: 2.5% !important;
    max-width: 95% !important;
  }

  .login-body {
    background-image: none;
    background-color: #d8d8d7;

    .mobeil-title,
    .mobeil-footer,
    .mobeil-ip {
      display: block;
    }

    .mobeil-title {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
    }

    .mobeil-footer {
      width: 330px;
      height: auto;
      position: absolute;
      left: 0;
      right: 0;
      bottom: -50px;
      margin: auto;
    }

    .mobeil-ip {
      width: 250px;
      height: auto;
      position: absolute;
      top: -145px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 10;
      animation: jump 3s infinite ease-in-out;
      display: inline-block;
      /* 确保动画应用于图片容器 */
    }

    @keyframes jump {

      0%,
      100% {
        transform: translateY(0);
      }

      50% {
        transform: translateY(-20px);
      }
    }

    .dialog-back {
      right: 20px;
      top: 20px;
    }

    .question-box {
      width: 330px;
      height: 430px;
      position: fixed;
      left: 0;
      right: 0;
      top: 100px;
      padding: 20px;
    }
  }
}
</style>